import { FilterMasterDataProps } from "src/entity/settings/masterdata";
import http from "../utils/http-common";
import { CreateSettingCombustion, FilterSettingCombustion, UpdateSettingCombustion } from "src/entity/settings/combustion";
import { CreateSettingFlareInfo, FilterSettingFlareInfo, UpdateSettingFlareInfo } from "src/entity/settings/flare-info";
import { CreateSettingFlareCompound, FilterSettingFlareCompound, UpdateSettingFlareCompound } from "src/entity/settings/flare-compound";
import { EmissionControl, SettingChemicalProp, SettingLoadingMethod } from "src/entity/settings/terminal-market";
import {
  CreateSettingWasteWaterTreatment,
  FilterSettingWasteWaterTreatment,
  UpdateSettingWasteWaterTreatment,
} from "src/entity/settings/waste-water";
import { SettingEmissionControlTank, SettingTankType } from "src/entity/settings/tank";
import {
  SettingComBySeries,
  SettingEqTypeFugitive,
  SettingFugitiveStatus,
  SettingSTDControlFugitive,
  SettingUncheckFugitive,
} from "src/entity/settings/fugitive";
import { QueryTagPIJob, ResponseSettingJob } from "src/entity/settings/job";
import { AxiosResponse } from "axios";
import {
  FilterDistinctSettingHistory,
  FullyResponseSettingHistory,
  ResponseGetDistinctSettingHistory,
  ResponseSettingHistory,
  SettingHistoryFilters,
} from "src/entity/settings/setting-history";

const baseMasterdataPath = "/api/masterdata";
const baseSettingJobPath = "/api/tasks";
const baseSettingHistoryPath = "/api/setting-history";

export const createSettingCombustion = (data: CreateSettingCombustion) => {
  return http.post(`${baseMasterdataPath}/setting-combustion`, data);
};
export const updateSettingCombustion = (data: UpdateSettingCombustion) => {
  return http.put(`${baseMasterdataPath}/setting-combustion`, data);
};
export const deleteSettingCombustion = (mappingId: string) => {
  return http.delete(`${baseMasterdataPath}/setting-combustion/${mappingId}`);
};
export const searchSettingCombustion = (data: FilterSettingCombustion) => {
  return http.post(`${baseMasterdataPath}/search/setting-combustion`, data);
};

// Flare Info
export const createSettingFlareInfo = (data: CreateSettingFlareInfo) => {
  return http.post(`${baseMasterdataPath}/setting-flare-info`, data);
};
export const updateSettingFlareInfo = (data: UpdateSettingFlareInfo) => {
  return http.put(`${baseMasterdataPath}/setting-flare-info`, data);
};
export const deleteSettingFlareInfo = (mappingId: string) => {
  return http.delete(`${baseMasterdataPath}/setting-flare-info/${mappingId}`);
};
export const searchSettingFlareInfo = (data: FilterSettingFlareInfo) => {
  return http.post(`${baseMasterdataPath}/search/setting-flare-info`, data);
};

// Flare Compound
export const createSettingFlareCompound = (data: CreateSettingFlareCompound) => {
  return http.post(`${baseMasterdataPath}/setting-flare-compound`, data);
};
export const updateSettingFlareCompound = (data: UpdateSettingFlareCompound) => {
  return http.put(`${baseMasterdataPath}/setting-flare-compound`, data);
};
export const deleteSettingFlareCompound = (mappingId: string) => {
  return http.delete(`${baseMasterdataPath}/setting-flare-compound/${mappingId}`);
};
export const searchSettingFlareCompound = (data: FilterSettingFlareCompound) => {
  return http.post(`${baseMasterdataPath}/search/setting-flare-compound`, data);
};

// Master & Distinct API
export const getFilterFlareInfoColumn = (type: string) => {
  return http.get(`${baseMasterdataPath}/setting-flare-info/filter-column-flare`, { params: { type } });
};
export const getFilterFlareCompoundColumn = (type: string) => {
  return http.get(`${baseMasterdataPath}/setting-flare-compound/filter-column-flare`, { params: { type } });
};
export const getFilterCombustionColumn = (type: string) => {
  return http.get(`${baseMasterdataPath}/setting-flare-info/filter-column-combustion`, { params: { type } });
};
export const getMasterData = (filter: FilterMasterDataProps) => {
  return http.get(`${baseMasterdataPath}`, { params: filter });
};

// Transportation & Margeting
export const getChemProperty = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-chem-prop-transportation-market?${query}`);
};

export const createChemProperty = (data: SettingChemicalProp) => {
  return http.post(`${baseMasterdataPath}/setting-chem-prop-transportation-market`, data);
};

export const updateChemProperty = (data: SettingChemicalProp) => {
  return http.patch(`${baseMasterdataPath}/setting-chem-prop-transportation-market`, data);
};

export const deleteChemProperty = (id: string) => {
  return http.delete(`${baseMasterdataPath}/setting-chem-prop-transportation-market/${id}`);
};

export const getFilterChemProperty = () => {
  return http.get(`${baseMasterdataPath}/setting-chem-prop-transportation-market/filter-chem-prop`);
};

export const getLoadingMethod = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-loading-method-transportation-market?${query}`);
};

export const getFilterLoadingMethod = () => {
  return http.get(`${baseMasterdataPath}/setting-loading-method-transportation-market/filter-loading-method`);
};

export const createLoadingMethod = (data: SettingLoadingMethod) => {
  return http.post(`${baseMasterdataPath}/setting-loading-method-transportation-market`, data);
};

export const updateLoadingMethod = (data: SettingLoadingMethod) => {
  return http.patch(`${baseMasterdataPath}/setting-loading-method-transportation-market`, data);
};

export const deleteLoadingMethod = (id: string) => {
  return http.delete(`${baseMasterdataPath}/setting-loading-method-transportation-market/${id}`);
};

export const getEmissionControl = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-emission-control-transportation-market?${query}`);
};

export const getFilterEmissionControl = () => {
  return http.get(`${baseMasterdataPath}/setting-emission-control-transportation-market/filter-emission-control`);
};

export const deleteEmissionControl = (id: string) => {
  return http.delete(`${baseMasterdataPath}/setting-emission-control-transportation-market/${id}`);
};

export const createEmissionControl = (data: EmissionControl) => {
  return http.post(`${baseMasterdataPath}/setting-emission-control-transportation-market`, data);
};

export const updateEmissionControl = (data: EmissionControl) => {
  return http.patch(`${baseMasterdataPath}/setting-emission-control-transportation-market`, data);
};

// Waste Water Treatment
export const createSettingWasteWater = (data: CreateSettingWasteWaterTreatment) => {
  return http.post(`${baseMasterdataPath}/setting-waste-water`, data);
};
export const updateSettingWasteWater = (data: UpdateSettingWasteWaterTreatment) => {
  return http.put(`${baseMasterdataPath}/setting-waste-water`, data);
};
export const deleteSettingWasteWater = (mappingId: string) => {
  return http.delete(`${baseMasterdataPath}/setting-waste-water/${mappingId}`);
};
export const searchSettingWasteWater = (data: FilterSettingWasteWaterTreatment) => {
  return http.post(`${baseMasterdataPath}/search/setting-waste-water`, data);
};
export const getFilterWasteWaterColumn = () => {
  return http.get(`${baseMasterdataPath}/setting-waste-water/all-filter`);
};

// Tank
export const getTankType = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-tank-type?${query}`);
};

export const createTankType = (data: SettingTankType) => {
  return http.post(`${baseMasterdataPath}/setting-tank-type`, data);
};

export const updateTankType = (data: SettingTankType) => {
  return http.patch(`${baseMasterdataPath}/setting-tank-type`, data);
};

export const deleteTankType = (id: string) => {
  return http.delete(`${baseMasterdataPath}/setting-tank-type/${id}`);
};

export const getFilterTankType = () => {
  return http.get(`${baseMasterdataPath}/setting-tank-type/filter-tank-type`);
};

export const getTankEmissionControl = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-emission-control-tank?${query}`);
};

export const createTankEmissionControl = (data: SettingEmissionControlTank) => {
  return http.post(`${baseMasterdataPath}/setting-emission-control-tank`, data);
};

export const updateTankEmissionControl = (data: SettingEmissionControlTank) => {
  return http.patch(`${baseMasterdataPath}/setting-emission-control-tank`, data);
};

export const deleteTankEmissionControl = (id: string) => {
  return http.delete(`${baseMasterdataPath}/setting-emission-control-tank/${id}`);
};

export const getFilterTankEmissionControl = () => {
  return http.get(`${baseMasterdataPath}/setting-emission-control-tank/filter-emission-tank`);
};

// Fugitive Status
export const getStatusFugitive = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-status-fugitive?${query}`);
};

export const createStatusFugitive = (data: SettingFugitiveStatus) => {
  return http.post(`${baseMasterdataPath}/setting-status-fugitive`, data);
};

export const updateStatusFugitive = (data: SettingFugitiveStatus) => {
  return http.patch(`${baseMasterdataPath}/setting-status-fugitive`, data);
};

export const deleteStatusFugitive = (id: string) => {
  return http.delete(`${baseMasterdataPath}/setting-status-fugitive/${id}`);
};

export const getFilterStatusFugitive = () => {
  return http.get(`${baseMasterdataPath}/setting-status-fugitive/filter-status-fugitive`);
};
// Fugitive Equipment Type
export const getEqIdFugitive = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-equipment-type-fugitive?${query}`);
};

export const createEqTypeFugitive = (data: SettingEqTypeFugitive) => {
  return http.post(`${baseMasterdataPath}/setting-equipment-type-fugitive`, data);
};

export const updateEqTypeFugitive = (data: SettingEqTypeFugitive) => {
  return http.patch(`${baseMasterdataPath}/setting-equipment-type-fugitive`, data);
};

export const deleteEqTypeFugitive = (id: string) => {
  return http.delete(`${baseMasterdataPath}/setting-equipment-type-fugitive/${id}`);
};

export const getFilterEqTypeFugitive = () => {
  return http.get(`${baseMasterdataPath}/setting-equipment-type-fugitive/filter-equipment-type-fugitive`);
};

// Uncheck Fugitive
export const getUncheckFugitive = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-uncheck-fugitive?${query}`);
};

export const createUncheckFugitive = (data: SettingUncheckFugitive) => {
  return http.post(`${baseMasterdataPath}/setting-uncheck-fugitive`, data);
};

export const updateUncheckFugitive = (data: SettingUncheckFugitive) => {
  return http.patch(`${baseMasterdataPath}/setting-uncheck-fugitive`, data);
};

export const deleteUncheckFugitive = (id: string) => {
  return http.delete(`${baseMasterdataPath}/setting-uncheck-fugitive/${id}`);
};

export const getFilterUncheckFugitive = () => {
  return http.get(`${baseMasterdataPath}/setting-uncheck-fugitive/filter-uncheck-fugitive`);
};

// STD Control Fugitive
export const getSTDControlFugitive = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-std-control-fugitive?${query}`);
};

export const createSTDControlFugitive = (data: SettingSTDControlFugitive) => {
  return http.post(`${baseMasterdataPath}/setting-std-control-fugitive`, data);
};

export const updateSTDControlFugitive = (data: SettingSTDControlFugitive) => {
  return http.patch(`${baseMasterdataPath}/setting-std-control-fugitive`, data);
};

export const deleteSTDControlFugitive = (id: string) => {
  return http.delete(`${baseMasterdataPath}/setting-std-control-fugitive/${id}`);
};

export const getFilterSTDControlFugitive = () => {
  return http.get(`${baseMasterdataPath}/setting-std-control-fugitive/filter-std-control-fugitive`);
};

// Component By Series Fugitive
export const getComBySeriesFugitive = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-com-by-series-fugitive?${query}`);
};

export const getOptionsComBySeriesFugitive = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-com-by-series-fugitive/options-series?${query}`);
};

export const createComBySeriesFugitive = (data: SettingComBySeries[]) => {
  return http.post(`${baseMasterdataPath}/setting-com-by-series-fugitive`, data);
};

export const updateComBySeriesFugitive = (data: SettingComBySeries[]) => {
  return http.patch(`${baseMasterdataPath}/setting-com-by-series-fugitive`, data);
};

export const deleteComBySeriesFugitive = (id: string) => {
  return http.delete(`${baseMasterdataPath}/setting-com-by-series-fugitive/${id}`);
};

export const getDetailComBySeries = (query: string) => {
  return http.get(`${baseMasterdataPath}/setting-com-by-series-fugitive/details?${query}`);
};

// Setting Job
export const getJobs = (): Promise<AxiosResponse<{ data: ResponseSettingJob[] }>> => {
  return http.get(`${baseSettingJobPath}/get-tasks`);
};
export const getJobById = (_id: string): Promise<AxiosResponse<{ data: ResponseSettingJob }>> => {
  return http.get(`${baseSettingJobPath}/get-task/${_id}`);
};
export const reRunJob = (_id: string, body?: QueryTagPIJob) => {
  return http.post(`${baseSettingJobPath}/re-run/${_id}`, body);
};

// Setting History
export const getSettingHistory = (params: SettingHistoryFilters): Promise<AxiosResponse<FullyResponseSettingHistory>> => {
  return http.get(`${baseSettingHistoryPath}`, { params });
};
export const getDistinctSettingHistoryColumns = (
  query: FilterDistinctSettingHistory,
): Promise<AxiosResponse<ResponseGetDistinctSettingHistory>> => {
  return http.get(`${baseSettingHistoryPath}/distinct`, { params: query });
};

export const SettingService = {
  createSettingCombustion,
  updateSettingCombustion,
  deleteSettingCombustion,
  searchSettingCombustion,
  createSettingFlareInfo,
  updateSettingFlareInfo,
  deleteSettingFlareInfo,
  searchSettingFlareInfo,
  createSettingFlareCompound,
  updateSettingFlareCompound,
  deleteSettingFlareCompound,
  searchSettingFlareCompound,
  getFilterFlareCompoundColumn,
  getFilterFlareInfoColumn,
  getMasterData,
  createSettingWasteWater,
  updateSettingWasteWater,
  deleteSettingWasteWater,
  searchSettingWasteWater,
  getFilterWasteWaterColumn,
  getJobs,
  getJobById,
  reRunJob,
  getSettingHistory,
  getDistinctSettingHistoryColumns,
};
